// src/hooks/useWelcomeAudioOnce.ts
import { useEffect } from 'react';
import { useAudioPlayer } from '../context/AudioPlayerContext';

const SESSION_KEY = 'welcomeAtmosphereAudioPlayed';
const WELCOME_SRC = '/sounds/welcomeatmosphere.mp3';

export const useWelcomeAudioOnce = () => {
  const { playExternal } = useAudioPlayer();

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY)) return;

    const timer = setTimeout(() => {
      playExternal(WELCOME_SRC);
      sessionStorage.setItem(SESSION_KEY, 'true');
    }, 2000);

    return () => clearTimeout(timer);
  }, [playExternal]);
};